import * as Configuration from '../../../app.constants.js';

export class ParametersService {
  constructor($http, AsyncRequestFactory) {
    this.$http = $http;
    this.AsyncRequestFactory = AsyncRequestFactory;
  }

  getTagGroups(companyId) {
    return this.$http.get(Configuration.constants.baseUrl + 'api/1.0/companies/' + companyId + '/tags-groups');
  }

  addTagGroup(companyId, data) {
    //adding a tag group needs to have a big timeout in order to update tasks table with the none tag id created when tag group created
    return this.$http.post(Configuration.constants.baseUrl + 'api/1.0/companies/' + companyId + '/tags-groups', data).then(result => result.data, error => error);
  }

  deleteTagGroup(companyId, tagGroupId) {
    return this.$http.delete(Configuration.constants.baseUrl + 'api/1.0/companies/' + companyId + '/tags-groups/' + tagGroupId);
  }

  updateTagGroup(companyId, tagGroupId, data) {
    return this.$http.put(Configuration.constants.baseUrl + 'api/1.0/companies/' + companyId + '/tags-groups/' + tagGroupId, data).then(result => result.data, error => error);
  }

  getTagGroup(companyId, tagGroupId) {
    return this.$http.get(Configuration.constants.baseUrl + 'api/1.0/companies/' + companyId + '/tags-groups/' + tagGroupId);
  }

  addTag(companyId, tagGroupId, data) {
    return this.$http.post(Configuration.constants.baseUrl + 'api/1.0/companies/' + companyId + '/tags-groups/' + tagGroupId + '/tags', data).then(result => result.data, error => error);
  }

  addCategory(companyId, tagGroupId, data) {
    return this.$http.post(Configuration.constants.baseUrl + 'api/1.0/companies/' + companyId + '/tags-groups/' + tagGroupId + '/categories', data).then(result => result.data, error => error);
  }

  updateTag(companyId, tagGroupId, tagId, data) {
    return this.$http.put(Configuration.constants.baseUrl + 'api/1.0/companies/' + companyId + '/tags-groups/' + tagGroupId + '/tags/' + tagId, data).then(result => result.data, error => error);
  }

  updateCategory(companyId, tagGroupId, categoryId, data) {
    return this.$http.put(Configuration.constants.baseUrl + 'api/1.0/companies/' + companyId + '/tags-groups/' + tagGroupId + '/categories/' + categoryId, data).then(result => result.data, error => error);
  }

  deleteTag(companyId, tagGroupId, tagId, replacementTagId) {
    return this.$http.delete(Configuration.constants.baseUrl + 'api/1.0/companies/' + companyId + '/tags-groups/' + tagGroupId + '/tags/' + tagId + '/' + replacementTagId);
  }
  deleteCategory(companyId, tagGroupId, categoryId) {
    return this.$http.delete(Configuration.constants.baseUrl + 'api/1.0/companies/' + companyId + '/tags-groups/' + tagGroupId + '/categories/' + categoryId);
  }

  exportTags(companyId) {
    return this.AsyncRequestFactory.post(companyId, Configuration.constants.baseUrl + 'api/1.0/companies/' + companyId + '/tags/export');
  }

  getSatisfactionSurveys(companyId, isInMarketingMode) {
    return this.$http.get(Configuration.constants.baseUrl + 'api/1.0/companies/' + companyId + '/satisfaction-surveys?is_marketing=' + (isInMarketingMode ? 1 : 0));
  }

  addSatisfactionSurvey(companyId, siteId, data) {
    return this.$http.post(Configuration.constants.baseUrl + 'api/1.0/companies/' + companyId + '/sites/' + siteId + '/satisfaction-surveys', data);
  }

  updateSatisfactionSurvey(companyId, siteId, satisfactionSurveyId, data) {
    return this.$http.put(Configuration.constants.baseUrl + 'api/1.0/companies/' + companyId + '/sites/' + siteId + '/satisfaction-surveys/' + satisfactionSurveyId, data);
  }

  getSatisfactionSurvey(companyId, siteId, satisfactionSurveyId) {
    return this.$http.get(Configuration.constants.baseUrl + 'api/1.0/companies/' + companyId + '/sites/' + siteId + '/satisfaction-surveys/' + satisfactionSurveyId);
  }

  updateSiteConversationsConfiguration(companyId, siteId, configuration) {
    return this.$http.put(Configuration.constants.baseUrl + 'api/1.0/companies/' + companyId + '/sites/' + siteId + '/conversations', configuration).then(result => result.data, error => error);
  }
  getSiteBusinessHoursConfiguration(companyId, siteId) {
    return this.$http.get(Configuration.constants.baseUrl + 'api/1.0/companies/' + companyId + '/sites/' + siteId + '/business-hours');
  }
  updateSiteBusinessHoursConfiguration(companyId, siteId, configuration) {
    return this.$http.put(Configuration.constants.baseUrl + 'api/1.0/companies/' + companyId + '/sites/' + siteId + '/business-hours', configuration);
  }

  getExports(companyId) {
    return this.$http.get(Configuration.constants.baseUrl + 'api/1.0/companies/' + companyId + '/exports');
  }
  getExportsSftpKey(companyId) {
    return this.$http.get(Configuration.constants.baseUrl + 'api/1.0/companies/' + companyId + '/exports/sftp-keys');
  }
  generateExportsSftpKey(companyId) {
    return this.$http.post(Configuration.constants.baseUrl + 'api/1.0/companies/' + companyId + '/exports/sftp-keys');
  }
  updateExports(companyId, data, test) {
    return this.$http.put(Configuration.constants.baseUrl + 'api/1.0/companies/' + companyId + '/exports?sftp_test=' + (test ? '1' : '0'), data);
  }

  getSite(companyId, siteId) {
    return this.$http.get(Configuration.constants.baseUrl + 'api/1.0/companies/' + companyId + '/sites/' + siteId);
  }

  static ParametersFactory($http, AsyncRequestFactory) {
    return new ParametersService($http, AsyncRequestFactory);
  }
}
ParametersService.ParametersFactory.$inject = ['$http', 'AsyncRequestFactory'];

